import { render, staticRenderFns } from "./PurchaseReceiveEdit.vue?vue&type=template&id=36c4daa7&"
import script from "./PurchaseReceiveEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseReceiveEdit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReceiveEdit.vue?vue&type=style&index=0&id=36c4daa7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports